import request from '@/utils/request'

export function pager(data) {
  return request({
    url: '/api/businessTaskRest/list',
    method: 'post',
    data,
  })
}

export function doAdd(data) {
  return request({
    url: '/api/businessTaskRest/',
    method: 'post',
    data,
  })
}

export function doEdit(data) {
  return request({
    url: '/api/businessTaskRest/',
    method: 'put',
    data,
  })
}

export function doDelete(data) {
  return request({
    url: '/api/businessTaskRest/' + data,
    method: 'delete',
  })
}
